<div *ngIf="isLoading">
  <loading-spinner></loading-spinner>
</div>

<form *ngIf="referralForm" #f="ngForm">
  <!-- MAIN BODY -->
  <div class="content__holder">

    <div class="button__row floating">
      <a class="button--box blue back" href="/forms">Back</a>
    </div>
    <!--<div class="form-steps open">-->

    <div class="form-steps open">
      <h2 class="form-steps__title">{{referralForm.name}}</h2>
    </div>

    <div class="row content-scroller">

    
      <div class="content__holder no-padding light">
        <ol *ngIf="referralForm.referralFormQuestionGroups" class="form-page__list">
          <li *ngFor="let rfqg of referralFormQuestionGroups; let i = index" class="form-page__item">
            <app-referral-form-question-group [referralFormQuestionGroup]="rfqg" class="form-page__content" [questionGroupIndex]=i+1>
            </app-referral-form-question-group>
          </li>

          <li class="form-page__item">
            <div class="form-page__content">
              <h3 class="form-page__title" id="section11"><span><i class="material-icons">done</i></span> Finish</h3>
              <section id="11" class="panel complete">
                <div class="answer">

                  <div class="button__row">
                    <div></div>
                    <button type="submit" class="form-page__button button--box save blue big">Submit</button>
                    <div></div>
                  </div>

                  <h3 class="sent-message hidden">
                    The form has been successfully sent
                    <i class="material-icons">done</i>
                  </h3>
                </div>
              </section>

            </div>
          </li>
        </ol>
      </div>
    </div>
  </div>
</form>
